<span class="snackbar-content" [ngClass]="data.type">
  <span class="material-symbols-outlined snackbar-icon">{{ icon }}</span>
  <span>{{ data.message }}</span>
</span>